"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _styles = _interopRequireDefault(require("./styles"));

var ModalContainer = _styles["default"].ModalContainer;

var LocationModal = function LocationModal(props) {
  var supplierDetails = props.supplierDetails,
      toggle = props.toggle,
      updateLocation = props.updateLocation,
      setNewLocation = props.setNewLocation,
      setToggle = props.setToggle;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    title: "".concat(supplierDetails.supplier.Name, " Locations"),
    toggle: toggle,
    setToggle: setToggle,
    height: "25.5rem",
    width: "37.5rem",
    "data-aurora-automation": "store-location-modal",
    containerClassName: "store-location-modal"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "lite italic"
  }, "Select a store to see item availability at that location only."), /*#__PURE__*/_react["default"].createElement(ModalContainer, null, supplierDetails.locations.map(function (location, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "location-container",
      "data-aurora-automation": "store-location-details-container",
      key: i,
      onClick: function onClick() {
        return updateLocation({
          setNewLocation: setNewLocation,
          setToggle: setToggle,
          toggle: toggle,
          supplier: supplierDetails.supplier,
          location: location
        });
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "location"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      "data-aurora-automation": "store-location-name"
    }, location.Name), /*#__PURE__*/_react["default"].createElement("span", {
      "data-aurora-automation": "store-location-address"
    }, "".concat(location.Street, ", ").concat(location.City, ", ").concat(location.State, " ").concat(location.Zip))), supplierDetails.location.StoreCode === location.StoreCode && /*#__PURE__*/_react["default"].createElement("i", {
      className: "far fa-check"
    }));
  })));
};

var _default = LocationModal;
exports["default"] = _default;